import React from 'react';
import {Route, Switch} from "react-router-dom";
import {home, notification, forgotPassword, createAccount, urlUpdate, scheduleType} from "../utils/routes";


import "../assets/sass/style.scss";
import Header from './layouts/header/header';
import Home from "./home/home";
import Footer from './layouts/footer/footer';
import Login from "./auth/Login";
import ProtectedRoute from "./protectedRoute";
import Notification from './notification/notification';
import ForgotPassword from './auth/ForgotPassword';
import CreateAccount from './auth/CreateAccount';
import UrlConfig from "./UrlAdd/urlConfig";
import ScheduleType from './ScheduleType/ScheduleType';


function App() {
    return (
        <div className="App">
            <Header/>
            <Switch>
                <ProtectedRoute path={"/"} component={Home} exact></ProtectedRoute>
                <ProtectedRoute path={home} component={Home} exact></ProtectedRoute>
                <ProtectedRoute path={urlUpdate} component={UrlConfig} exact></ProtectedRoute>
                <Route path="/login" component={Login} exact/>
                <Route path={notification} component={Notification} exact></Route>
                <Route path={forgotPassword} component={ForgotPassword} exact></Route>
                <Route path={createAccount} component={CreateAccount} exact></Route>
                <Route path={scheduleType} component={ScheduleType} exact></Route>
            </Switch>
            <Footer/>
        </div>
    );
}

export default App;
